export interface IFileFilterListItem {
    id: string;
    code: string;
    name: string;
}

export class FileFilterListItem implements IFileFilterListItem {
    id: string;
    code: string;
    name: string;

    constructor();
    constructor(obj: IFileFilterListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
    }
}